export type OperatorSymbol =  '=' | '<' | '>'| '<=' | '>=' | '<>'| '!=' | 'IS NULL';

export interface OperatorOption {
    value: OperatorSymbol;
    label: OperatorSymbol;
}

export enum ConditionTypes {
    CURRENCY = 'currency',
    PERCENTAGE = 'percentage',
    FLOAT = 'float',
    INTEGER = 'integer',
    DATE = 'date',
    BOOL = 'boolean',
    STRING = 'string',
    OPERATOR_IS_NULL = 'IS NULL',
}

export interface ConditionData {
    label: string;
    value: string;
    type?: ConditionTypes;
    maxDecimals?: number;
}

export interface SelectedCondition {
    [x: string]: string | ConditionData;
    metric: string;
    operator: OperatorSymbol;
    type: ConditionTypes;
    value: string;
}

export type SelectedConditions = SelectedCondition[];

export type ChangeSelectedCondition = (name: string) => (newValue: SelectedCondition[]) => void;

export type OnChangeValue = ConditionData | null | string;

export type OnChange = (entity: string, index: number) => (entry: OnChangeValue) => void; 

export interface Result {
	[x: string]: {
		shortDescKey: string;
		maxDecimals: number;
		type: ConditionTypes
	}
}
